import { Component, computed, input, linkedSignal, output, WritableSignal } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TaskStatus } from '@app/shared/types/enums/task-status.enum';
import { TaskStatusSelectEnum } from '@app/shared/types/models/task/task-status.model';
import { UiSelectComponent } from '@app/shared/ui/select/ui-select.component';
import { UiStatusBadgeComponent } from '@app/shared/ui/status-badge/ui-status-badge.component';
import { PROFFEO_TASK_STATUS_TOKENS } from '@app/shared/ui/tokens/task-status.tokens';
import { ProffeoUiSelectOption } from '@app/shared/ui/types/select.types';
import { ProffeoUiDensity, ProffeoUiStatusBadgeMode } from '@app/shared/ui/types/ui.types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-task-status-select',
  imports: [MatTooltip, TranslatePipe, UiSelectComponent, UiStatusBadgeComponent],
  templateUrl: './task-status-select.component.html'
})
export class TaskStatusSelectComponent {
  protected readonly taskStatusOrder: TaskStatus[] = Object.values(TaskStatus);

  protected readonly statusOptions: ProffeoUiSelectOption<TaskStatus>[] = this.taskStatusOrder.map(status => ({
    value: status,
    label: PROFFEO_TASK_STATUS_TOKENS[status].translationKey
  }));

  protected readonly selectedStatus: WritableSignal<TaskStatus> = linkedSignal(() => this.taskStatus());

  protected readonly statusBadgeMode = computed((): ProffeoUiStatusBadgeMode =>
    this.mode() === TaskStatusSelectEnum.RECTANGLES ? 'badge' : 'dot'
  );

  protected readonly badgeDensity = computed((): ProffeoUiDensity => (this.small() ? 'compact' : 'comfortable'));

  public readonly statusSelected = output<TaskStatus>();
  public readonly taskStatus = input.required<TaskStatus>();
  public readonly readonly = input<boolean>(true);
  public readonly small = input<boolean>(false);
  public readonly mode = input<TaskStatusSelectEnum>(TaskStatusSelectEnum.RECTANGLES);
  /** Shows the status name next to the dot/badge in the trigger; when hidden, the name is a tooltip. */
  public readonly showLabel = input<boolean>(true);

  protected onStatusChange(status: TaskStatus | TaskStatus[] | null): void {
    if (status === null || Array.isArray(status) || status === this.selectedStatus()) {
      return;
    }

    this.selectedStatus.set(status);
    this.statusSelected.emit(status);
  }
}
